import React, { useState } from 'react';
import { NewspaperIcon, PlusIcon } from '@heroicons/react/24/outline';
import { SubHeaderTextTW } from '../../../../../../tailwindComponents/subHeaderText/SubHeaderTextTW';
import { Show } from '../../../../../shared/Show';
import { BodyTextTW } from '../../../../../../tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW } from '../../../../../../tailwindComponents/buttonTW/ButtonTW';
import { EditAppointmentNotesForm } from '../../Forms/EditAppointmentNotesForm';
import { ISigningAppointmentEditFormData } from '../../../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { useSelectAppointmentFromPathParam } from '../../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { eSigningMethod } from '../../../../../../types/signingAppointment/eSigningMethod';
import { determineCanEdit } from '../../../EditAppointment/util';
import { isNil } from 'lodash';

/*NOTES SECTION*/
export const AppointmentNotes: React.FC<{
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
  iconClassNames: string;
}> = ({ onSaveEditions, iconClassNames }) => {
  const [doEditNotes, setDoEditNotes] = useState<boolean>(false);
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  if (!appointmentFromPath) {
    return null;
  }

  const eventHasNotes = !isNil(appointmentFromPath.notes) && appointmentFromPath.notes?.length !== 0;
  const title = appointmentFromPath.signingMethod === eSigningMethod.wetSign ? 'Wet Signing Notes' : 'Notes';
  const canEdit = determineCanEdit(appointmentFromPath);

  if (!canEdit && !eventHasNotes) {
    return null;
  }

  return (
    <Show
      when={
        !appointmentFromPath.isSignatureSyncAppointment ||
        (eventHasNotes && appointmentFromPath.isSignatureSyncAppointment)
      }
    >
      <section>
        <div className={'flex justify-start'}>
          <NewspaperIcon className={iconClassNames} />
          <SubHeaderTextTW className={'mr-5'}>{title}</SubHeaderTextTW>
        </div>
        <Show
          when={doEditNotes}
          fallback={
            <>
              <div className={'p-2'}>
                <BodyTextTW className={'whitespace-pre-line'}>{appointmentFromPath.notes}</BodyTextTW>
              </div>
              <Show when={canEdit}>
                <ButtonTW secondary={true} onClick={() => setDoEditNotes(true)}>
                  <div className={'flex justify-start'}>
                    <PlusIcon className={iconClassNames} />
                    <BodyTextTW>{eventHasNotes ? 'Edit Note' : 'Add Note'}</BodyTextTW>
                  </div>
                </ButtonTW>
              </Show>
            </>
          }
        >
          <EditAppointmentNotesForm onSaveEditions={onSaveEditions} setDoEditNotes={setDoEditNotes} />
        </Show>
      </section>
    </Show>
  );
};
